export default __webpack_public_path__ + "static/media/group-default.d05e7270.svg";